export default {
  apiKey: "AIzaSyDN-Erfjez7FLOqRtgdAZbaAzLxv-g4U9Y",
  authDomain: "tagset2017.firebaseapp.com",
  databaseURL: "https://tagset2017.firebaseio.com",
  projectId: "tagset2017",
  storageBucket: "tagset2017.appspot.com",
  messagingSenderId: "689556051903"
};


// WEBPACK FOOTER //
// ./src/config.js